"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var addTruthyParamsToUrl_1 = __importDefault(require("./addTruthyParamsToUrl"));
// Append `next` query parameter to a URL, if provided.
var urlWithNext = function (url, next) { return addTruthyParamsToUrl_1.default(url, { next: next }); };
exports.default = urlWithNext;
